<div class=""  >
    <div class="reward-item">
      <div class="icon">
        <mvms-image *ngIf="reward.isUnlocked" [imageId]="reward.iconId" [isAvatar]="true"></mvms-image>
      </div>
      <h3 class="title" [title]="reward.title" (click)="goToBadges()">{{reward.title}}</h3>
    </div>      
  </div>